
import React from 'react';
import { Panel, PanelHeader, PanelBody } from './../../components/panel/panel.jsx';
import NokiaSeal from './../workinstructions/images/nokiaseal.png';
import TransportShipmentPreparement from './../workinstructions/images/TransportShipmentPreparement.png';
import LoadingcheckShipment from './../workinstructions/images/LoadingcheckShipment.png';
import ZZETES00 from './../workinstructions/images/ZZETES00.png';
import ZZETES00outbound from './../workinstructions/images/ZZETES-outbound.png';
import ALUtransportcontrole from './../workinstructions/images/ALUtransportcontrole.png';

class ALUOutbound extends React.Component {
    async componentDidMount() {
    document.title = "Alu Outbound";    
  }
	
	render() {
		return (
			<div>
			{/*		<ol className="breadcrumb float-xl-end">
					<li className="breadcrumb-item"><a href="#/">Home</a></li>
					<li className="breadcrumb-item"><a href="#/">Extra</a></li>
					<li className="breadcrumb-item active">Cookie Acceptance Banner</li>
				</ol>	
				<h1 className="page-header">Cookie Acceptance Banner <small>header small text goes here...</small></h1> */}
				<Panel>
					<PanelHeader>Outbound-Operations of MN-NI</PanelHeader>
					<PanelBody>
						<h2>Outbound orders Sorting</h2>
						<p>There are 4 types of orders: Red for express which have to be delivered on next workingday<br/>
						Blue EU-orders which will be shipped economic<br/>
						Green export-orders and yellow telefonica-orders<br/>
						Orders going to RSLC will sticcked label OTM <br/>
						Red orders addressed to Microsoft/Google/Deutsche Telekom (DE)/MNET (DE)/DE-CIX (DE)/BWI (DE) will sticked DHL EXpress 12:00 delivery<br/>
						</p>
						<h2>Printer configuration</h2>
						<p>Use ST SU3 =&gt; go to tab Default =&gt; go to Output Device and fill in LOCL =&gt; Go to Tab Parameters and fill in fields "LGN" and "XUG" NL01/NL02/NL03/NL04 for A4-printer
						=&gt; save</p>
						<h2>Create Shipment</h2>						
						<p>Use ST VT01N =&gt; at transportplanningPt fill in NL01 =&gt; at Shipmenttype , select Road =&gt; Enter =&gt; at forward Agent type in DHL DDI or DHL  TDI =&gt; Save</p>
			
						<h2>Change shipment at outbound/delete delivery from shipment</h2>						
						<p>Use ST VL02N =&gt; fill in outbound-delivery =&gt; go to the delivery you want to delete =&gt; =&gt; =&gt; </p>
			
						<h2>Outbound ZZETES00-2-2 /packing</h2>						
						<p><img src={ZZETES00outbound } alt="ZZETES00-outbound " style={{ maxWidth: '100%', height: 'auto' }} /></p>			
						<p>Use ZZETES00 =&gt; select 2 =&gt; select outbound =&gt; Scan the delivery on paper in SAP =&gt; 
						Enter =&gt; Fill in Packing Material of outerbox (S14NL, S72NL, S59NL, S62NL, KBNL, MBNL, GBNL, EURONL, 1/2ENL, EURO etc..) 
						=&gt; Scan the HU of the items in till all items are scanned and end with F2 =&gt; Fill in weight =&gt; Enter =&gt; 
						stick the Address-label on the outerbox with visible HU2-barcode =&gt; do the shipment-paper in the sack and stick on the outerbox =&gt; 
						put the package on the right pallet/trolley =&gt; If it is for EU, then register in OTM or DHL to printout the AWB
						</p>
						<p><img src={ALUtransportcontrole} alt="Loading check Shipment" style={{ maxWidth: '100%', height: 'auto' }} /></p>
							
						<h2>Outbound ZZETES00-2-3-1 /Shipment Preparement</h2>	
						<p>Scan HU2-code in SAP then scan AWB in the right shipment</p>
							<p><img src={TransportShipmentPreparement} alt="Transport Shipment Preparement" style={{ maxWidth: '100%', height: 'auto' }} /></p>							
						<h2>Outbound ZZETES00-2-3-2 /Transport Check Shipment</h2>	
							<p><img src={NokiaSeal} alt="Nokia Seal" style={{ maxWidth: '100%', height: 'auto' }} /></p>
						<p>Use handscanner and scan the HU2-barcode</p>

						<h2>Outbound ZZETES00-2-3-3 /Transport Closing Shipment</h2>	
						<p>Select  the right shipment </p>

						<h2>Print shipping-paper and address-label manually</h2>						
						<p>Use ST VL02N =&gt; fill in outbounddelivery =&gt; go to Issue Delivery Output =&gt; Select ZBL1 for Address-label =&gt; =&gt; </p>
							
						<h2>Change Measurement/Weight of a shipment</h2>						
						<p>Use ST VL02N =&gt; fill in outbounddelivery =&gt; go to Pack =&gt; Go to Volume =&gt; now you can change measurement and weight =&gt; Save </p>
							
						<h2>Change shipment at outbound/delete delivery from shipment</h2>						
						<p>Use ST VL02N =&gt; fill in outbounddelivery =&gt; go to the delivery =&gt; =&gt; =&gt; </p>

						<h2>Telefonica and Orange orders</h2>						
						<p>For telefonica, set printer 03 and for Orange set printer 05 =&gt; After printing the labels, change the printer back to LOCL =&gt;
						=&gt; Start ZLAC =&gt; select delivery-nr =&gt; F8 =&gt; replace box, stick labels on the right locations on the new box
						=&gt; Start common outbound-process =&gt; start VL02N =&gt; select delivery Outbound =&gt; 
						Go to ZPA1 =&gt; =&gt; =&gt;
						</p>
						<p>Process them like common outbound, but for sending them with AWB, use OTM =&gt; Enter =&gt; printout 3X for common items. for SCRAP printout 4X =&gt;
						=&gt; Go to ZPAC =&gt; 
						After done, fill in access, select Orange /Telefonica, fill in quantity, order-nr =&gt;
						</p>
							
						<h2>Speedair/CTDI/Elisa</h2>	
						<p>Work like common outbound, but in OTM, fill in all deliveries in one time for consolidation
						</p>
						<h2>OTM</h2>						
						<p>Go to Manage deliveries =&gt; for Red order fill first 0 in then the delivery-nr, for White orders only scan in delivery-Nr  
						=&gt; Enter =&gt; select OTM =&gt; click on "Actions" =&gt; Click on "Routing Options" =&gt; at "Transport Mode" select Courier =&gt;
						Click Show Options for Red order select Express, for 12:00h Red order select deliver before 12:00, for White orders select Economic
						=&gt; Click OK =&gt; Close Screen =&gt; Go back to Manage deliveries =&gt; click on + =&gt; When the indicator is green then you can do the next step, Click on "Buy Shipment" =&gt; Click on delivery =&gt; 
						=&gt; Click on "Specific Field" =&gt; Fill phone-number of from shipment-paper in field "phone" =&gt; Click on "Finished" =&gt;
						Select OTM =&gt; click on "Actions" =&gt; Click "Secure Options" =&gt; close screen =&gt; click on Manage Result =&gt;
						click on "Buy shipment" =&gt; go to "documents" =&gt; click on "glsses"-icon =&gt; CTRL+P to printout AWB
						</p>
						<p>
							If there is error , then you can try to fill the pickingdate is today
						</p>
						<h2>OTM from scratch</h2>						
						<p>Go to Manage deliveries =&gt; for Red order fill first 0 in then the delivery-nr, for White orders only scan in delivery-Nr  
						=&gt; Enter =&gt; select OTM =&gt; click on "Actions" =&gt; Click on "Routing Options" =&gt; at "Transport Mode" select Courier =&gt;
						Click Show Options for Red order select Express, for 12:00h Red order select deliver before 12:00, for White orders select Economic
						=&gt; Click OK =&gt; Close Screen =&gt; Go back to Manage deliveries =&gt; click on + =&gt; Click on "Buy Shipment" =&gt; Click on delivery =&gt; 
						=&gt; Click on "Specific Field" =&gt; Fill phone-number of from shipment-paper in field "phone" =&gt; Click on "Finished" =&gt;
						Select OTM =&gt; click on "Actions" =&gt; Click "Secure Options" =&gt; close screen =&gt; click on Manage Result =&gt;
						click on "Buy shipment" =&gt; go to "documents" =&gt; click on "glsses"-icon =&gt; CTRL+P to printout AWB
						</p>
					<footer style={{ marginTop: '2rem', padding: '1rem 0', borderTop: '1px solid #ddd' }}>
  <p style={{ textAlign: 'center', fontSize: '0.9rem', color: '#666' }}>
    &copy; Nov 2025 by TQT Tong. All rights reserved.
  </p>
</footer>

					</PanelBody>
				</Panel>
		
			</div>
		)
	}
}

export default ALUOutbound;
